<div class="transaction-amount-field-label">Amount</div>

<div class="transaction-amount-field-container" [class.disabled]="isDebitLegsDisabled$ | async">
  @if ((amountOption$ | async) === 'EXACT_AMOUNT') {
    <div class="amount-preffix">&nbsp;{{ (currency$ | async) || 'USD' | currencySign }}&nbsp;</div>
  }
  <div
    class="transaction-amount-field-wrapper"
    [class.transaction-amount-field-wrapper--percentage]="(amountOption$ | async) === 'PERCENTAGE'"
    #textInputWrapperRef
  >
    @if ((amountOption$ | async) === 'EXACT_AMOUNT') {
      <input
        #textInputRef
        type="text"
        class="transaction-amount-field-input"
        [formControl]="moveAmount"
        autocomplete="off"
        id="moveAmount"
        mask="separator.2"
        [attr.disabled]="(isDebitLegsDisabled$ | async) ? true : null"
        maxlength="20"
        [size]="4"
        thousandSeparator=","
        placeholder="00.00"
        (ngModelChange)="onChange($event)"
        (blur)="onBlur()"
      />
    }

    @if ((amountOption$ | async) === 'PERCENTAGE') {
      <input
        #textInputRef
        appPercentageField
        type="text"
        class="transaction-amount-field-input"
        [formControl]="moveAmount"
        autocomplete="off"
        [maxlength]="10"
        [attr.disabled]="(isDebitLegsDisabled$ | async) ? true : null"
        id="moveAmount"
        [size]="moveAmount.value ? 1 : 4"
        placeholder="00.00"
        (ngModelChange)="onChange($event)"
        (blur)="onBlur()"
      />
    }
  </div>
  @if ((amountOption$ | async) === 'PERCENTAGE') {
    <div class="amount-suffix">%</div>
  }
</div>
